var map = {
	"./Pa01.jpg": 11566,
	"./Pa02.jpg": 42915,
	"./Pa03.jpg": 56294,
	"./Pa04.jpg": 62755,
	"./Pa05.jpg": 57686,
	"./Pa06.jpg": 40740,
	"./Pa07.jpg": 3173,
	"./Pa08.jpg": 19544,
	"./Pa09.jpg": 65245,
	"./Pa10.jpg": 3841,
	"./Pa11.jpg": 71741,
	"./Pa12.jpg": 32345,
	"./Pa13.jpg": 32658,
	"./Pa14.jpg": 65864,
	"./Pa15.jpg": 97554,
	"./Pa16.jpg": 29432,
	"./Pa17.jpg": 63857,
	"./Pa18.jpg": 50862,
	"./Pa19.jpg": 41112,
	"./Pa20.jpg": 82718,
	"./Pa21.jpg": 58637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58416;